module.exports = __webpack_public_path__ + "static/img/popup2-swiper3.a17b87d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/popup2-swiper3.png
// module id = v2gi
// module chunks = 0